import { useQuery } from "@tanstack/react-query";
import { dropdownService } from "../api/services/dropdownService";

export const useRegionOptions = (cityId?: string) => {
  const {
    data: regionOptions,
    isLoading: isRegionOptionsLoading,
  } = useQuery({
    queryKey: ["regionOptions", cityId],
    queryFn: () => dropdownService.getRegionOptions(cityId),
    enabled: !!cityId,
  });

  return {
    regionOptions: regionOptions || [],
    isRegionOptionsLoading,
  };
};
